/**
 * Os cards: busca, o card em pagina inteira, e a vida dele.
 *
 * O card e UM componente so (`CardDoIssue.vue`), usado pela pagina e pela
 * gaveta do quadro. Se virarem dois, divergem em duas semanas.
 */
export const nav = {
    permissao: 'deck.issues:ver',
    section: 'Trabalho',
    title: 'Tarefas',
    icon: 'task_alt',
    route: '/tarefas',
    sequence: 5,
};

export default [
    {
        path: '/tarefas',
        name: 'tarefas',
        component: () => import('./pages/TarefasPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.issues:ver' },
    },
    {
        // Antes de `/tarefas/:issueKey` de proposito: sem isso, "nova" seria
        // lido como a CHAVE de um card, e cairia na tela errada.
        path: '/tarefas/nova',
        name: 'tarefa-nova',
        component: () => import('./pages/IssueFormPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.issues:criar' },
    },
    {
        // Mesmo motivo de `/tarefas/nova`: precisa vir antes de `:issueKey`.
        path: '/tarefas/importar',
        name: 'tarefa-importar',
        component: () => import('./pages/IssueImportPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.issues:criar' },
    },
    {
        // O parametro NAO se chama `key` de proposito: com `props: true`, o
        // Vue Router entrega os parametros da rota como props do componente
        // -- e `key` e um nome reservado do Vue (o atributo de reconciliacao
        // do VDOM). Um `defineProps({ key })` e silenciosamente ignorado, e
        // a pagina do card nunca recebe a chave. Foi exatamente isso que
        // aconteceu aqui: a rota inteira nunca funcionou.
        path: '/tarefas/:issueKey',
        name: 'tarefa',
        component: () => import('./pages/TarefaPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'deck.issues:ver' },
    },
    {
        // A "vida do card": a barra de tempo por coluna, os bloqueios e quem
        // trabalhou. E o relatorio que se leva para uma reuniao.
        path: '/tarefas/:issueKey/historia',
        name: 'tarefa-historia',
        component: () => import('./pages/VidaDoCardPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'deck.issues:ver' },
    },
];
